import type { TFunction } from 'i18next';
import type {
  CompareGranularity,
  ComparePeriod,
} from '@/persistence/config-db';

/**
 * Render a {@link ComparePeriod} as a localized human-readable label.
 *
 *   monthly    → "Mart 2025"
 *   quarterly  → "Q1 2025"
 *   semiannual → "H1 2025"
 *   yearly     → "2025"
 *
 * Uses i18next's `t` so the call site supplies its component-scoped
 * translator. Pulled into its own module so it can also be used by
 * widget rendering in step 4 without circular imports.
 */
export function formatPeriod(
  t: TFunction,
  granularity: CompareGranularity,
  period: ComparePeriod,
): string {
  if (granularity === 'yearly') return String(period.year);
  if (granularity === 'monthly') {
    const month = t(`mode.month.${period.sub ?? 1}`);
    return `${month} ${period.year}`;
  }
  if (granularity === 'quarterly') {
    return `Q${period.sub ?? 1} ${period.year}`;
  }
  // semiannual
  return `H${period.sub ?? 1} ${period.year}`;
}
